import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { ProductIconSizes, ProductIconVariant } from "../ProductIcon.types";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(["container"]);
const baseStyle = definePartsStyle({
    container: {
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
        borderRadius: "7.5px",
        background: "semantic.brand.secondary-dimmed",
    },
});
const sizes = {
    [ProductIconSizes.SM]: definePartsStyle({
        container: {
            borderRadius: "6px",
            padding: 1,
        },
    }),
    [ProductIconSizes.MD]: {},
};
const variants = {
    [ProductIconVariant.GREEN]: definePartsStyle({
        container: {
            background: "semantic.brand.secondary-dimmed",
        },
    }),
    [ProductIconVariant.YELLOW]: definePartsStyle({
        container: {
            background: "semantic.brand.quaternary-light",
        },
    }),
    [ProductIconVariant.RED]: definePartsStyle({
        container: {
            background: "semantic.brand.quinary-light",
        },
    }),
    [ProductIconVariant.PURPLE]: definePartsStyle({
        container: {
            background: "semantic.brand.primary-dimmed",
        },
    }),
    [ProductIconVariant.BLUE]: definePartsStyle({
        container: {
            background: "semantic.brand.tertiary-dimmed",
        },
    }),
};
const VisualBlockTheme = defineMultiStyleConfig({
    baseStyle,
    sizes,
    variants,
    defaultProps: {
        size: ProductIconSizes.MD,
        variant: ProductIconVariant.GREEN,
    },
});
export default VisualBlockTheme;
//# sourceMappingURL=ProductIcon.default.js.map